// Lib
import React from 'react';
import styled from 'styled-components';

// SVG
import { ReactComponent as Info } from 'assets/svg/info.svg';
import { ReactComponent as Move } from 'assets/svg/move.svg';
import { ReactComponent as Reject } from 'assets/svg/reject.svg';
import { ReactComponent as Check } from 'assets/svg/check.svg';
import { ReactComponent as Restore } from 'assets/svg/restore.svg';
import { ReactComponent as AttachFile } from 'assets/svg/attachFile.svg';
import { ReactComponent as Contact } from 'assets/svg/contact.svg';
import { ReactComponent as Note } from 'assets/svg/note.svg';
import { ReactComponent as AddCandidate } from 'assets/svg/addCandidate.svg';
import { ReactComponent as JobPosting } from 'assets/svg/jobPosting.svg';
import { ReactComponent as TrackingProgress } from 'assets/svg/trackingProgress.svg';
import { ReactComponent as Candidates } from 'assets/svg/сandidates.svg';

const Icons: any = {
  info: <Info />,
  move: <Move />,
  reject: <Reject />,
  check: <Check />,
  restore: <Restore />,
  attachFile: <AttachFile />,
  contact: <Contact />,
  note: <Note />,
  addCandidate: <AddCandidate />,
  jobPosting: <JobPosting />,
  trackingProgress: <TrackingProgress />,
  сandidates: <Candidates />,
};

const IconWrapper = styled.span<any>`
  display: inline-block;

  & i {
    display: inherit;
  }

  & svg {
    width: ${props => (props.width ? props.width : '25px')};
    height: ${props => (props.height ? props.height : '25px')};
    fill: ${props => props.color};
  }
`;

interface IconProps {
  type: string;
  onClick?: VoidFunction;
  color?: any;
  width?: string;
  height?: string;
  css?: any;
}

const Icon: React.FC<IconProps> = ({
  type,
  onClick,
  color,
  width,
  height,
  css,
  ...props
}): JSX.Element => (
  <IconWrapper color={color} width={width} height={height} onClick={onClick} css={css} {...props}>
    <i>{Icons[type]}</i>
  </IconWrapper>
);

export default Icon;
